import { formatTime } from '@/lib/format';
import type { Slot } from '@/types/product.slot';

/** Radix Select forbids an empty-string item value → sentinel for "no choice". */
export const SLOT_NONE = '__none__';

/** Only OPEN, non-blacked-out slots with remaining capacity are pickable. */
export function selectableSlots(slots: Slot[]): Slot[] {
  return slots.filter(
    (s) => s.availableCount > 0 && s.status !== 'CLOSED' && s.status !== 'BLACKED_OUT',
  );
}

/** Prefer the ISO `slotStartAt`/`slotEndAt` (localStart may be a bare label). */
export function slotTimeLabel(slot: Slot): string {
  const start = slot.slotStartAt ?? slot.localStart;
  const end = slot.slotEndAt ?? slot.localEnd;
  return `${formatTime(start)}${end ? `–${formatTime(end)}` : ''}`;
}
